(function() {
  var JLB_FAV_KEY = 'jlb_wishlist';
  function getFavs() { try { return JSON.parse(localStorage.getItem(JLB_FAV_KEY)) || []; } catch(e) { return []; } }
  function saveFavs(a) { localStorage.setItem(JLB_FAV_KEY, JSON.stringify(a)); }

  window.jlbPdpToggleFav = function(btn, handle) {
    var favs = getFavs();
    var idx = favs.indexOf(handle);
    var action = idx === -1 ? 'add' : 'remove';
    if (action === 'add') favs.push(handle); else favs.splice(idx, 1);
    saveFavs(favs);
    btn.classList.toggle('active', action === 'add');
    btn.style.transform = 'scale(1.3)';
    setTimeout(function() { btn.style.transform = ''; }, 200);
    if (typeof window.jlbServerSync === 'function') window.jlbServerSync(handle, action);
  };

  function initFavs() {
    var favs = getFavs();
    document.querySelectorAll('.jlb-pdp__fav-btn, .jlb-pdp__rel-fav').forEach(function(btn) {
      var m = (btn.getAttribute('onclick') || '').match(/'([^']+)'\)/);
      if (m && favs.indexOf(m[1]) !== -1) btn.classList.add('active');
    });
  }

  function initGallery() {
    var mainImg = document.getElementById('jlbMainImg');
    var thumbs = document.getElementById('jlbThumbs');
    if (!thumbs || !mainImg) return;
    thumbs.addEventListener('click', function(e) {
      var btn = e.target.closest('.jlb-pdp__thumb');
      if (!btn) return;
      thumbs.querySelectorAll('.jlb-pdp__thumb').forEach(function(t) { t.classList.remove('active'); });
      btn.classList.add('active');
      mainImg.src = btn.dataset.src;
      mainImg.alt = btn.dataset.alt;
    });

    // Flèches gauche/droite sur l'image principale — pilotent les vignettes
    var prevBtn = document.getElementById('jlbGalPrev');
    var nextBtn = document.getElementById('jlbGalNext');
    function step(dir) {
      var list = Array.from(thumbs.querySelectorAll('.jlb-pdp__thumb'));
      if (!list.length) return;
      var current = list.findIndex(function(t) { return t.classList.contains('active'); });
      if (current === -1) current = 0;
      var target = (current + dir + list.length) % list.length;
      list[target].click(); // ressynchronise image principale, vignette active et index lightbox
    }
    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); step(1); });
  }

  var lbImages = [], lbIdx = 0;
  function initLightbox() {
    var wrap = document.getElementById('jlbMainImgWrap');
    var lb = document.getElementById('jlbLightbox');
    var overlay = document.getElementById('jlbLbOverlay');
    var lbImg = document.getElementById('jlbLightboxImg');
    var lbClose = document.getElementById('jlbLightboxClose');
    var lbPrev = document.getElementById('jlbLbPrev');
    var lbNext = document.getElementById('jlbLbNext');
    var counter = document.getElementById('jlbLbCounter');
    if (!lb) return;

    var thumbBtns = document.querySelectorAll('.jlb-pdp__thumb');
    if (thumbBtns.length) {
      thumbBtns.forEach(function(t) { lbImages.push({ src: t.dataset.src, alt: t.dataset.alt }); });
    } else {
      var mi = document.getElementById('jlbMainImg');
      if (mi) lbImages.push({ src: mi.src, alt: mi.alt });
    }

    function open(i) {
      lbIdx = (i + lbImages.length) % lbImages.length;
      lbImg.src = lbImages[lbIdx].src;
      lbImg.alt = lbImages[lbIdx].alt;
      lb.classList.add('open'); overlay.classList.add('open');
      if (counter) counter.textContent = (lbIdx + 1) + ' / ' + lbImages.length;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      lb.classList.remove('open'); overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    if (wrap) wrap.addEventListener('click', function() { open(lbIdx); });
    if (lbClose) lbClose.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    if (lbPrev) lbPrev.addEventListener('click', function() { open(lbIdx - 1); });
    if (lbNext) lbNext.addEventListener('click', function() { open(lbIdx + 1); });

    var thumbsEl = document.getElementById('jlbThumbs');
    if (thumbsEl) {
      thumbsEl.addEventListener('click', function(e) {
        var btn = e.target.closest('.jlb-pdp__thumb');
        if (!btn) return;
        lbIdx = Array.from(thumbsEl.querySelectorAll('.jlb-pdp__thumb')).indexOf(btn);
      });
    }

    document.addEventListener('keydown', function(e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'ArrowLeft') lbPrev.click();
      if (e.key === 'ArrowRight') lbNext.click();
      if (e.key === 'Escape') close();
    });
  }

  function initVariants() {
    var dataEl = document.getElementById('jlbProductData');
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch(e) { return; }
    var variants = data.variants;
    var options = data.options;
    var selOpts = [];

    var variantIdEl = document.getElementById('jlbVariantId');
    if (!variantIdEl) return;
    var initVariantId = parseInt(variantIdEl.value);
    var initVariant = variants.find(function(v) { return v.id === initVariantId; });
    if (initVariant) selOpts = [initVariant.option1, initVariant.option2, initVariant.option3];

    function findVariant() {
      return variants.find(function(v) {
        return (!options[0] || v.option1 === selOpts[0]) &&
               (!options[1] || v.option2 === selOpts[1]) &&
               (!options[2] || v.option3 === selOpts[2]);
      });
    }

    function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

    function updateUI(v) {
      if (!v) return;
      document.getElementById('jlbVariantId').value = v.id;
      var pw = document.getElementById('jlbPriceWrap');
      var sp = document.getElementById('jlbStickyPrice');
      if (pw) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var disc = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          pw.innerHTML = '<span class="jlb-pdp__price-compare">' + money(v.compare_at_price) + '</span>' +
            '<span class="jlb-pdp__price-current jlb-pdp__price-current--sale">' + money(v.price) + '</span>' +
            '<span class="jlb-pdp__price-save">Vous économisez ' + money(v.compare_at_price - v.price) + '</span>';
        } else {
          pw.innerHTML = '<span class="jlb-pdp__price-current">' + money(v.price) + '</span>';
        }
      }
      if (sp) sp.textContent = money(v.price);
      var av = document.getElementById('jlbAvailability');
      if (av) av.innerHTML = v.available
        ? '<span class="jlb-pdp__avail-dot jlb-pdp__avail-dot--green"></span> En stock — expédié sous 24–48h'
        : '<span class="jlb-pdp__avail-dot jlb-pdp__avail-dot--red"></span> Rupture de stock';
      var atc = document.getElementById('jlbAtcBtn');
      if (atc) { atc.disabled = !v.available; atc.style.opacity = v.available ? '' : '.5'; }
      if (v.featured_image) {
        var mi = document.getElementById('jlbMainImg');
        if (mi) {
          mi.src = v.featured_image.src;
          document.querySelectorAll('.jlb-pdp__thumb').forEach(function(t, i) {
            var match = t.dataset.src && t.dataset.src.indexOf(v.featured_image.src.split('?')[0]) !== -1;
            if (match) { t.classList.add('active'); lbIdx = i; } else t.classList.remove('active');
          });
        }
      }
    }

    document.querySelectorAll('.jlb-pdp__option-btns').forEach(function(group) {
      group.addEventListener('click', function(e) {
        var btn = e.target.closest('.jlb-pdp__opt-btn');
        if (!btn || btn.classList.contains('unavailable')) return;
        var oi = parseInt(group.dataset.optionIndex);
        group.querySelectorAll('.jlb-pdp__opt-btn').forEach(function(b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        selOpts[oi] = btn.dataset.value;
        var v = findVariant();
        if (v) updateUI(v);
      });
    });

    // Marquer options indisponibles
    variants.forEach(function(v) {
      if (!v.available) {
        [v.option1, v.option2, v.option3].forEach(function(val, oi) {
          if (!val) return;
          var group = document.querySelector('[data-option-index="' + oi + '"]');
          if (!group) return;
          var btn = group.querySelector('[data-value="' + val + '"]');
          if (btn) {
            var hasAvail = variants.some(function(vv) {
              return vv.available && (oi === 0 ? vv.option1 : oi === 1 ? vv.option2 : vv.option3) === val;
            });
            if (!hasAvail) btn.classList.add('unavailable');
          }
        });
      }
    });
  }

  function initQty() {
    var input = document.getElementById('jlbQty');
    var minus = document.getElementById('jlbQtyMinus');
    var plus = document.getElementById('jlbQtyPlus');
    if (!input) return;
    if (minus) minus.addEventListener('click', function() { if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1; });
    if (plus) plus.addEventListener('click', function() { if (parseInt(input.value) < 99) input.value = parseInt(input.value) + 1; });
  }

  function initATC() {
    var form = document.getElementById('jlbAddToCartForm');
    var btn = document.getElementById('jlbAtcBtn');
    var text = document.getElementById('jlbAtcText');
    var stickyBtn = document.getElementById('jlbStickyAtcBtn');
    if (!form || !btn) return;

    function showToast(name) {
      var t = document.getElementById('jlbAtcToast');
      if (!t) {
        t = document.createElement('div');
        t.id = 'jlbAtcToast';
        t.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg><span></span>';
        document.body.appendChild(t);
      }
      t.querySelector('span').textContent = (name || 'Produit') + ' ajouté au panier';
      t.classList.remove('jlb-toast--hide');
      t.classList.add('jlb-toast--show');
      clearTimeout(t._timer);
      t._timer = setTimeout(function() { t.classList.replace('jlb-toast--show', 'jlb-toast--hide'); }, 3000);
    }

    function doATC() {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('loading');
      text.innerHTML = '<span class="jlb-atc-spinner"></span>Ajout en cours…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: document.getElementById('jlbVariantId').value, quantity: parseInt(document.getElementById('jlbQty').value) || 1 })
      }).then(function(r) { return r.json(); }).then(function(data) {
        btn.disabled = false;
        btn.classList.remove('loading'); btn.classList.add('success');
        text.innerHTML = '<svg class="jlb-atc-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>Ajouté !';
        showToast(data && data.title ? data.title : null);
        setTimeout(function() { btn.classList.remove('success'); text.textContent = 'Ajouter au panier'; }, 2800);
      }).catch(function() { btn.disabled = false; btn.classList.remove('loading'); text.textContent = 'Ajouter au panier'; form.submit(); });
    }

    form.addEventListener('submit', function(e) { e.preventDefault(); doATC(); });
    if (stickyBtn) stickyBtn.addEventListener('click', doATC);
  }

  function initBuyNow() {
    var btn = document.getElementById('jlbBuyNowBtn');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var vid = document.getElementById('jlbVariantId').value;
      var qty = parseInt(document.getElementById('jlbQty').value) || 1;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: qty })
      }).then(function() {
        window.location.href = '/checkout';
      }).catch(function() {
        btn.disabled = false;
      });
    });
  }


  function initTabs() {
    var tabs = document.querySelectorAll('.jlb-pdp__tab');
    var panels = document.querySelectorAll('.jlb-pdp__tab-content');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        if (tab.dataset.tab === 'reviews') {
          var section = document.getElementById('jlb-reviews-section');
          if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        tabs.forEach(function(t) { t.classList.remove('active'); });
        panels.forEach(function(p) { p.classList.remove('active'); });
        tab.classList.add('active');
        var panel = document.querySelector('[data-tab-panel="' + tab.dataset.tab + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  }

  function initStickyBar() {
    var bar = document.getElementById('jlbStickyBar');
    var atcBtn = document.getElementById('jlbAtcBtn');
    if (!bar || !atcBtn || !window.IntersectionObserver) return;
    new IntersectionObserver(function(entries) {
      bar.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(atcBtn);
  }

  function initSizeGuide() {
    var btn = document.getElementById('jlbSizeGuideBtn');
    var modal = document.getElementById('jlbSizeModal');
    var overlay = document.getElementById('jlbSizeModalOverlay');
    var closeBtn = document.getElementById('jlbSizeModalClose');
    if (!btn || !modal) return;

    var tabs = modal.querySelectorAll('.jlb-sg-tab');
    var panels = modal.querySelectorAll('.jlb-sg-panel');

    function selectTab(name) {
      var found = false;
      tabs.forEach(function(t) {
        var on = t.getAttribute('data-sg-tab') === name;
        t.classList.toggle('active', on);
        if (on) found = true;
      });
      panels.forEach(function(p) {
        p.classList.toggle('active', p.getAttribute('data-sg-panel') === name);
      });
      // Fallback : si la catégorie n'existe pas, active le premier onglet
      if (!found && tabs.length) {
        tabs[0].classList.add('active');
        if (panels.length) panels[0].classList.add('active');
      }
    }

    tabs.forEach(function(t) {
      t.addEventListener('click', function() { selectTab(t.getAttribute('data-sg-tab')); });
    });

    function open() {
      // Onglet contextuel selon le type de produit
      selectTab(btn.getAttribute('data-size-category') || 'lit');
      modal.classList.add('open');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('open');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    btn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    try { initFavs(); } catch(e) { console.warn('initFavs', e); }
    try { initGallery(); } catch(e) { console.warn('initGallery', e); }
    try { initLightbox(); } catch(e) { console.warn('initLightbox', e); }
    try { initVariants(); } catch(e) { console.warn('initVariants', e); }
    try { initQty(); } catch(e) { console.warn('initQty', e); }
    try { initATC(); } catch(e) { console.warn('initATC', e); }
    try { initBuyNow(); } catch(e) { console.warn('initBuyNow', e); }
    try { initTabs(); } catch(e) { console.warn('initTabs', e); }
    try { initStickyBar(); } catch(e) { console.warn('initStickyBar', e); }
    try { initSizeGuide(); } catch(e) { console.warn('initSizeGuide', e); }
  });
})();
